import { Partner, PartnerScope } from '@/api/hooks/useTenantConfig'
import { Checkbox, Modal, Typography, theme } from 'antd'
import { useEffect, useState } from 'react'

const { Text } = Typography

interface ScopesModalProps {
  open: boolean
  onClose: () => void
  partner: Partner | null
  availableScopes: PartnerScope[]
  onSave: (scopes: PartnerScope[]) => void
  loading?: boolean
}

export const ScopesModal = ({
  open,
  onClose,
  partner,
  availableScopes,
  onSave,
  loading,
}: ScopesModalProps) => {
  const { token } = theme.useToken()
  const [selectedScopes, setSelectedScopes] = useState<PartnerScope[]>([])

  useEffect(() => {
    if (partner) {
      setSelectedScopes(
        (partner.scopes || []).filter((s) => availableScopes.includes(s)),
      )
    }
  }, [partner, availableScopes])

  const handleSave = () => {
    onSave(selectedScopes)
  }

  const handleChange = (scope: PartnerScope, checked: boolean) => {
    if (checked) {
      setSelectedScopes([...selectedScopes, scope])
    } else {
      setSelectedScopes(selectedScopes.filter((s) => s !== scope))
    }
  }

  return (
    <Modal
      title={`Manage Scopes - ${partner?.tenant_name || ''}`}
      open={open}
      onOk={handleSave}
      onCancel={onClose}
      okText='Save Scopes'
      confirmLoading={loading}
      width={500}
    >
      <div style={{ marginBottom: 16 }}>
        <Text type='secondary'>
          Select the permissions this partner will have when accessing your
          data.
        </Text>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {availableScopes.map((scope) => (
          <div
            key={scope}
            style={{
              padding: '12px 16px',
              backgroundColor: selectedScopes.includes(scope)
                ? token.colorPrimaryBg
                : token.colorFillQuaternary,
              borderRadius: 8,
              border: `1px solid ${selectedScopes.includes(scope) ? token.colorPrimary : token.colorBorder}`,
            }}
          >
            <Checkbox
              checked={selectedScopes.includes(scope)}
              onChange={(e) => handleChange(scope, e.target.checked)}
            >
              <div>
                <Text strong style={{ fontFamily: 'monospace' }}>
                  {scope}
                </Text>
              </div>
            </Checkbox>
          </div>
        ))}

        {availableScopes.length === 0 && (
          <Text type='secondary'>No scopes available</Text>
        )}
      </div>
    </Modal>
  )
}
